// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card {
  margin-top: 20%;
  display: flex;
  width: 80%;
  margin-right: auto;
  margin-left: auto;
  flex-direction: column;
  align-items: flex-end;
}

mat-form-field {
  width: 100%;
}

.country-container {
  display: flex;
  justify-content: space-between;
}

@media only screen and (min-width: 601px) {
  mat-card {
    width: 580px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/toolbox/filter/filter.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AACA;EACE,WAAA;AAEF;;AAAA;EACE,aAAA;EACA,8BAAA;AAGF;;AAAA;EACE;IACE,YAAA;EAGF;AACF","sourcesContent":["mat-card {\n  margin-top: 20%;\n  display: flex;\n  width: 80%;\n  margin-right: auto;\n  margin-left: auto;\n  flex-direction: column;\n  align-items: flex-end;\n}\nmat-form-field {\n  width: 100%;\n}\n.country-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n@media only screen and (min-width: 601px) {\n  mat-card {\n    width: 580px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
